import React from 'react';
import PropTypes from 'prop-types';

const PriceMatrixHead = (props) => {
  const { leadTimes, leadTimeText } = props;

  return (
    <thead>
      <tr>
        <th className="qty">Quantities</th>
        {leadTimes.map((qty) => (
          <th key={qty}>
            <div className="leadtime-container">
              <div className="leadtime-calendar">
                <span className="time">{qty}</span>
                <span className="unit">{leadTimeText(qty)}</span>
              </div>
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
  leadTimeText: null,
};

PriceMatrixHead.propTypes = {
  leadTimeText: PropTypes.func,
  leadTimes: PropTypes.array,
};

export default PriceMatrixHead;
